import React from 'react'
import LangLegalNamingComponent from '../../components/marketingGuidelines/marketingComponents/LangLegalNaming/LangLegalNamingComponent'
import { Col } from 'react-bootstrap';
import './langLegalNamingLayout.scss'

class LangLegalNamingLayout extends React.Component {
    render() {
        return <div className="langlegal-layout">
            <div className="warning-section">
                <Col xs={1} align="center">
                    <span className='icon-warning-grey' />
                </Col>
                <p>Use of the Life Fitness logo requires the expressed written consent from Life Fitness. Contact <a href="mailto:developers@lifefitness.com">developers@lifefitness.com</a> for information.</p>
            </div>
            <br />
            <h2>Language, Legal and Product Naming</h2>
            <LangLegalNamingComponent />
        </div>
    }
}

export default LangLegalNamingLayout



// WEBPACK FOOTER //
// ./src/layouts/LangLegalNaming/LangLegalNamingLayout.js